module.exports = __webpack_public_path__ + "img/2a23b9f.png";